export const publicSchoollistColumn = [
    {
        label: "s_n",
        name: "S.N"
    },
    {
        label: "schoolName",
        name: "SChool Name"
    },
    {
        label: "address",
        name: "School Address"
    },
]